import { render } from "./SettingsPlan.vue?vue&type=template&id=12c94f30"
import script from "./SettingsPlan.vue?vue&type=script&lang=js"
export * from "./SettingsPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__